import 'slick-carousel';

$('.slider-hero .slider__slides').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	infinite: true,
	arrows: true,
	dots: false
});

$('#product .product__slider').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	dots: false,
	arrows: false,
	infinite: false,
	asNavFor: '#product .product__thumbs'
});

$('#product .product__thumbs').slick({
	slidesToShow: 4,
	slidesToScroll: 4,
	dots: false,
	arrows: false,
	infinite: false,
	asNavFor: '#product .product__slider',
	focusOnSelect: true
});

$('.slider-sidebar .slider__slides').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	fade: true,
	arrows: false,
	dots: false,
	swipe: false,
	draggable: false,
	touchMove: false
});
